export class RiskAssessment{
    constructor(public data?: {
        OfferID?: Number,
        Q1?: Boolean,
        Q2?: Boolean,
        Q3?: Boolean,
        Q4?: Boolean,
        Q5?: Boolean,
        Q6?: Boolean,
        Q7?: Boolean,
        Q8?: Boolean,
        Q9?: Boolean,
        Q10?: Boolean,
        Q11?: Boolean,
        Q12?: Boolean,
        Q13?: Boolean,
        Q14?: Boolean,
        Q15?: Boolean,
        Q16?: Boolean,
        Q17?: Boolean,
        Q18?: Boolean,
        Q19?: Boolean,
        Q20?: Boolean,
        Q21?: Boolean,
        Q22?: Boolean,
        Q23?: Boolean,
        Q24?: Boolean,
        Q25?: Boolean,
        Q26?: Boolean,
        Q27?: Boolean,
        Q28?: Boolean,
        Q29?: Boolean,
        UnableToGetData?: Boolean
    }){}
}